import { useEffect, useState } from "react";
import axios from "../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { Button, Col, Form, Row } from "react-bootstrap";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment/moment";

export default function CorporateInvoice() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [invoiceFile, setInvoiceFile] = useState(null);
    const [invoiceFiles, setInvoiceFiles] = useState([]);

    const fetchInvoiceList = () => {
        setLoading(true);
        axios.get(`/corporate-client/invoice-file-lists/${id}`)
            .then((res) => {
                setLoading(false);
                if (res.data.status) {
                    setInvoiceFiles(res.data.data || []);
                }
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (id) {
            fetchInvoiceList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleInvoiceChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type !== "application/pdf") {
                message.error("Only PDF files are allowed.");
                e.target.value = null;
                setInvoiceFile(null);
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                message.error("Maximum file size is 5MB.");
                e.target.value = null;
                setInvoiceFile(null);
                return;
            }
            setInvoiceFile(file);
        } else {
            setInvoiceFile(null);
        }
    };

    const handleInvoiceUpload = async (e) => {
        e.preventDefault();

        if (!invoiceFile) {
            message.error('Please select a PDF file to upload.');
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('pdf', invoiceFile);

            const res = await axios.post(`/corporate-client/save-invoice-file/${id}`, formData);
            setLoading(false);

            if (res.data.status) {
                message.success(res.data.message || 'Invoice uploaded successfully.');
                fetchInvoiceList();
                setInvoiceFile(null);
                e.target.reset(); // clear the file input
            } else {
                message.error(res.data.message || 'Failed to upload invoice.');
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
            message.error(err?.response?.data?.message || err?.message || 'Unable to upload invoice.');
        }
    };

    const invoiceColumns = [
        {
            name: "Invoice File",
            selector: (row) => row.fileName || row.pdf, // Adjust based on your API response structure
            cell: (row) => (
                <a href={row.url || row.url} target="_blank" rel="noreferrer">
                    {row.fileName || "View Invoice"}
                </a>
            )
        },
        {
            name: "Uploaded At",
            selector: (row) => moment(row.createdAt).format("MM-DD-YYYY HH:mm A"),
        }
    ];

    return (
        <LoadingOverlay active={loading} spinner text="loading...">
            <div className="right_cont">
                <div className="right_banner_banner_cnt">
                    <div className="travel_deals_admin">
                        <div className="cert_det_inner">
                            <h2>Corporate Client Invoice of {invoiceFiles[0]?.clientDetails[0]?.name}</h2>
                            <Button variant="secondary" onClick={() => history.goBack()} className="mb-3">
                                Back
                            </Button>
                        </div>

                        <div className="py-2">
                            <h3 className="text-center mb-4 fw-bold text-primary">Invoice Upload</h3>

                            <Form onSubmit={handleInvoiceUpload}>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload PDF Invoice *</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="invoice"
                                                accept="application/pdf"
                                                onChange={handleInvoiceChange}
                                                required
                                            />
                                            <Form.Text className="text-muted">
                                                Only PDF files are allowed. Maximum file size is 5MB.
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-end mb-4">
                                    <Button variant="primary" type="submit" className="px-5 py-2 fw-bold">
                                        Upload Invoice
                                    </Button>
                                </div>
                            </Form>

                            <div className="invoice-file-list">
                                <h5 className="mb-3">Uploaded Invoices</h5>
                                <DataTable
                                    columns={invoiceColumns}
                                    data={invoiceFiles}
                                    pagination
                                    striped
                                    highlightOnHover
                                    noHeader
                                    responsive
                                    noDataComponent="No invoices uploaded yet."
                                    customStyles={{
                                        headCells: {
                                            style: {
                                                backgroundColor: '#f8f9fa',
                                                color: '#495057',
                                                fontWeight: 'bold',
                                                fontSize: '15px',
                                            },
                                        },
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </LoadingOverlay>
    );
}
